/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Field_EmailInputs */

const en_us2_search_field_email = /** @type {(inputs: Search_Field_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email`)
};

const pt_br2_search_field_email = /** @type {(inputs: Search_Field_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail`)
};

const es_419_search_field_email = /** @type {(inputs: Search_Field_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correo electrónico`)
};

const pt_pt2_search_field_email = /** @type {(inputs: Search_Field_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail`)
};

const fr_fr2_search_field_email = /** @type {(inputs: Search_Field_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail`)
};

const de_de2_search_field_email = /** @type {(inputs: Search_Field_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail`)
};

const it_it2_search_field_email = /** @type {(inputs: Search_Field_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email`)
};

/**
* | output |
* | --- |
* | "Email" |
*
* @param {Search_Field_EmailInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_field_email = /** @type {((inputs?: Search_Field_EmailInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Field_EmailInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_field_email(inputs)
	if (locale === "es-419") return es_419_search_field_email(inputs)
	if (locale === "pt-PT") return pt_pt2_search_field_email(inputs)
	if (locale === "fr-FR") return fr_fr2_search_field_email(inputs)
	if (locale === "de-DE") return de_de2_search_field_email(inputs)
	if (locale === "it-IT") return it_it2_search_field_email(inputs)
	return en_us2_search_field_email(inputs)
});
export { search_field_email as "search.field_email" }